import { eventType } from './../config/settings.js';
import { store } from './store.js';
import { providerSelector } from './selectors.js';
import { pushBack } from './../store/history.js';
import { processDoubleEvents, processSupportNavEvents } from './casino.js';
import { handleLoveEvents } from './mygames.js'

const prevScrollPos = [0, 0];
const scrollEvent = new UIEvent('scroll', {
	view: window,
	bubbles: true,
	cancelable: true
});

function setPreviousScrollPos(x, y) {
	prevScrollPos[0] = x;
	prevScrollPos[1] = y;
}

/* Refactor
	The rendering part is the same as in allgames.js - don't duplicate
	The rest belongs in other functions

 */
function render() {
	/* Refator
		providerSelector in selectors.js already provides this functionality...
	 */
	if (!store.get().filters.provider) {
		return;
	}

	const providerGames = providerSelector(store.get());

	if (providerGames.length > 0) {
		const { name } = providerGames[0].provider;
		document.getElementById('provider-title').textContent = name;
	}

	setPreviousScrollPos(window.scrollX, window.scrollY);
	const $tabsContainer = document.getElementsByClassName('tabs-container')[0];
	setTimeout(() => {
		$tabsContainer.classList.add('u-dn');
	}, 500);

	const providerGamesGrid = document.getElementById('provider-game-grid');
	const gamesTemplate = store.get().templates.games;
	const templateContext = {
		...store.get().gameResource,
		...{
			gameData: {
				all: providerGames,
			}
		}
	};
	const gamesHtml = gamesTemplate(templateContext);
	providerGamesGrid.innerHTML = gamesHtml;

	const providerContainer = document.getElementsByClassName('games-by-provider-container')[0];
	providerContainer.classList.add('games-by-provider-container--is-open');
	setTimeout(() => {
		providerContainer.classList.add('u-transform-none');
	}, 300);

	return;
}

function bindScrollToWindow() {
	window.dispatchEvent(scrollEvent);
}

function destroy() {
	const providerContainer = document.getElementsByClassName('games-by-provider-container')[0];
	const closeButton = providerContainer.getElementsByClassName('icon-close')[0];
	closeButton.removeEventListener(eventType, destroy);
	//providerContainer.removeEventListener('scroll', bindScrollToWindow);

	providerContainer.removeEventListener('click', processDoubleEvents);
	providerContainer.removeEventListener('click', processSupportNavEvents);

	providerContainer.classList.remove('games-by-provider-container--is-open', 'u-transform-none');
	const $tabsContainer = document.getElementsByClassName('tabs-container')[0];
	$tabsContainer.classList.remove('u-dn');
	window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
	store.get().filters.set({ provider: '' });
}

function initEventListners() {
	const providerContainer = document.getElementsByClassName('games-by-provider-container')[0];
	const closeButton = providerContainer.getElementsByClassName('icon-close')[0];
	closeButton.addEventListener(eventType, pushBack);
	//providerContainer.addEventListener('scroll', bindScrollToWindow, { passive: true });

	providerContainer.removeEventListener('click', processDoubleEvents);
	providerContainer.removeEventListener('click', processSupportNavEvents);
	providerContainer.removeEventListener('click', handleLoveEvents);

	providerContainer.addEventListener('click', processDoubleEvents);
	providerContainer.addEventListener('click', processSupportNavEvents);
	providerContainer.addEventListener('click', handleLoveEvents);
}

store.on('update', (currentState, prevState) => {
	if (currentState !== prevState) {
		render();
	}
});

function init(providerCode) {
	initEventListners();
	store.get().filters.set({ provider: providerCode });
	render();
}

export { init, destroy };




// WEBPACK FOOTER //
// ./mobile-core/src/casino/providergames.js